export interface RecolorInfo {
    blobUrl: string;
}

export class RecolorCache {
    private static instance: RecolorCache;
    public static getInstance(): RecolorCache {
        if (!RecolorCache.instance) {
            RecolorCache.instance = new RecolorCache();
        }
        return RecolorCache.instance;
    }

    private cache: Map<string, RecolorInfo[]>;

    public constructor() {
        this.cache = new Map<string, RecolorInfo[]>();
    }

    public addToCache(modelKey: string, recolorInfo: RecolorInfo[]): void {
        this.cache.set(modelKey, recolorInfo);
    }

    public getFromCache(modelKey: string): RecolorInfo[] | undefined {
        return this.cache.get(modelKey);
    }

    public clearCache(): void {
        this.cache.forEach((item) => {
            item.forEach((element) => {
                if (element.blobUrl) {
                    URL.revokeObjectURL(element.blobUrl);
                }
            });
        });
        this.cache.clear();
    }
}
